/**
 * A dialog component to call the optimisation algorithm.
 */

import loaderIcon from '../../../../images/loader.svg';

const ID = 'aims_msp_selected-sites-panel_optimise-dialog';
const TEMPLATE = `
<div id="${ID}" class="modal process-dialog" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Optimisation Algorithm</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>
`;

const TEMPLATE_BODY_FORM = `
        <div class="form-group row">
          <label for="inputName" class="col-sm-3 col-form-label">Name</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="inputName" value="">
          </div>
        </div>
        <div class="form-group row">
          <label for="selectedSites" class="col-sm-3 col-form-label">Pre-selected sites</label>
          <div class="col-sm-9">
            <textarea id="selectedSites" class="form-control-plaintext" readonly>No sites selected.</textarea>
          </div>
        </div>
        <div class="form-group row">
          <label for="selectedCriteria" class="col-sm-3 col-form-label">Selected criteria</label>
          <div class="col-sm-9">
            <textarea id="selectedCriteria" class="form-control-plaintext" readonly>No criteria selected.</textarea>
          </div>
        </div>
        <div class="form-group row">
          <label for="selectAlgorithm" class="col-sm-3 col-form-label">Algorithm</label>
          <div class="col-sm-9">
            <select class="form-control" id="selectAlgorithm"></select>
          </div>
        </div>
        <div class="form-group row">
          <label for="inputSampleSize" class="col-sm-3 col-form-label">Sample size</label>
          <div class="col-sm-9">
            <input type="number" class="form-control" id="inputSampleSize" value="10">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputNumberGeneration" class="col-sm-3 col-form-label">Number generation</label>
          <div class="col-sm-9">
            <input type="number" class="form-control" id="inputNumberGeneration" value="10">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputPopulation" class="col-sm-3 col-form-label">Population</label>
          <div class="col-sm-9">
            <input type="number" class="form-control" id="inputPopulation" value="10">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputSurvivalCount" class="col-sm-3 col-form-label">Survival Count</label>
          <div class="col-sm-9">
            <input type="number" class="form-control" id="inputSurvivalCount" value="2">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputNearestNeighborSize" class="col-sm-3 col-form-label">Measurement site distance jitter</label>
          <div class="col-sm-9">
            <input type="number" class="form-control" id="inputNearestNeighborSize" value="10">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Must-have sites</label>
          <div class="col-sm-9">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="cbMustHaveSites">
              <label class="form-check-label" for="cbMustHaveSites">Always keep must-have sites</label>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="inputNoiseGenerationNumber" class="col-sm-3 col-form-label">Noise generation number</label>
          <div class="col-sm-9">
            <input type="number" class="form-control" id="inputNoiseGenerationNumber" value="0">
          </div>
        </div>
`;

const TEMPLATE_FOOTER_FORM =  `
        <button type="button" class="btn btn-danger btn-optimise">Start Optimisation</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
`;

const TEMPLATE_BODY_PROCESSING = `
        <p class="name">Name: <span></span></p>
        <p>Optimising site selection ...</p>
        <div class="loader"><span class="current-progress">0</span></div>
        <div class="log"></div>
`;

const TEMPLATE_FOOTER_PROCESSING =  `
        <button type="button" class="btn btn-primary btn-minimise-maximise">Minimise</button>
        <button type="button" class="btn btn-primary btn-show-current-sample">Show current sample</button>
        <button type="button" class="btn btn-primary btn-pause-resume">Pause</button>
        <button type="button" class="btn btn-primary btn-stop">Stop</button>
`;

const TEMPLATE_BODY_RESULTS = `
        <p>Results</p>
        <div class="results"></div>
`;

const TEMPLATE_FOOTER_RESULTS =  `
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
`;

export default class OptimiseDialog {

  /**
   * Constructor
   * @param selectedSitesModel
   * @param referenceSitesHashModel
   * @param activeDataset
   * @param algorithmsModel
   * @param variablesModel
   * @param worker
   */
  constructor(selectedSitesModel, referenceSitesHashModel, activeDataset, algorithmsModel, variablesModel, worker) {

    // Cache references.
    this._selectedSitesModel = selectedSitesModel;
    this._referenceSitesHashModel = referenceSitesHashModel;
    this._algorithmsModel = algorithmsModel;
    this._variablesModel = variablesModel;
    this._activeDataset = activeDataset;

    // Worker
    this._worker = worker;

    // Array of optimised samples and scores per generation
    this._results = [];
    this._settings = null;

    // Create element
    this._$modalEl = $(TEMPLATE);
    this._$modalElBody = this._$modalEl.find('.modal-body');
    this._$modalElBody.html(TEMPLATE_BODY_FORM);
    this._$modalElFooter = this._$modalEl.find('.modal-footer');
    this._$modalElFooter.html(TEMPLATE_FOOTER_FORM);

    // Add dynamic content
    this._createDynamicFormContent();

    // Insert the template to render the list.
    $('body').append(this._$modalEl);

    // Display the dialog.
    this._$modalEl.modal({
      backdrop: 'static',
      keyboard: false
    });

    // Clean up after close.
    this._$modalEl.on('hidden.bs.modal', () => {
      this._worker.postMessage({
        'cmd': 'stop',
        'msg': ''
      });
      this._$modalEl.remove();
    });

    // Add an event handler to buttons.
    this._$modalElFooter.find('.btn-optimise').click(this._handleOptimiseClick.bind(this));
  }

  /**
   * Create the dynamic part of the modal box body content, like a dynamic list of check boxes for all criteria
   * @private
   */
  _createDynamicFormContent() {
    const selectedSites =  [];
    Object.keys(this._selectedSitesModel.getData()).forEach(key => {
      selectedSites.push(this._referenceSitesHashModel.getData()[key].name);
    });
    if (selectedSites.length > 0) {
      this._$modalEl.find('#selectedSites').val(selectedSites.join('\n'));
    }

    const selectedCriteria =  [];
    $('table#calculations tbody tr').get().forEach(row => {
      if ($(row).find('td.criteria-active input:checked').length === 1) {
        selectedCriteria.push($(row).data('name') + ' (weight: ' + $(row).find('td.criteria-weight input').val() + ')');
      }
    });
    if (selectedCriteria.length > 0) {
      this._$modalEl.find('#selectedCriteria').val(selectedCriteria.join('\n'));
    }

    const $selectAlgorithm = this._$modalEl.find('#selectAlgorithm');
    this._algorithmsModel.getItems().forEach((_algorithm) => {
      $selectAlgorithm.append(`<option value="${_algorithm.id}">${_algorithm.name}</option>`);
    });
  }

  /**
   * Handle click on the start-optimising-button
   * @param event
   * @private
   */
  _handleOptimiseClick(event) {
    this._$modalElBody = this._$modalEl.find('.modal-body');
    const nameStr = this._$modalElBody.find('input#inputName').val();
    const sampleSizeStr = this._$modalElBody.find('input#inputSampleSize').val();
    const numberGenerationStr = this._$modalElBody.find('input#inputNumberGeneration').val();
    const nearestNeighborSizeStr = this._$modalElBody.find('input#inputNearestNeighborSize').val();
    const populationStr = this._$modalElBody.find('input#inputPopulation').val();
    const survivalCountStr = this._$modalElBody.find('input#inputSurvivalCount').val();
    const algorithm = this._$modalElBody.find('select#selectAlgorithm').val();
    const useMustHaveSites = this._$modalElBody.find('input#cbMustHaveSites').prop('checked');
    const noiseGenerationNumberStr = this._$modalElBody.find('input#inputNoiseGenerationNumber').val();

    const selectedCriteria = this._buildCriteriaArray('spatialReconstruction');
    const categoryFairnessVariables = this._buildCriteriaArray('categoryFairness');
    const historicWeightingCriteria = this._buildCriteriaArray('historicalWeighting');

    this._settings = {
      'name': nameStr,
      'initialSample': Object.keys(this._selectedSitesModel.getData()),
      'sampleSize': sampleSizeStr,
      'numberGeneration': numberGenerationStr,
      'populationSize': populationStr,
      'nearestNeighbourSize': nearestNeighborSizeStr,
      'algorithm': algorithm,
      'selectedVariables': selectedCriteria,
      'categoryFairnessVariables': categoryFairnessVariables,
      'historicWeightingCriteria': historicWeightingCriteria,
      'survivalCount': survivalCountStr,
      'useMustHaveSites': useMustHaveSites,
      'noiseGenerationNumber': noiseGenerationNumberStr
    };

    this._worker.postMessage({
      'cmd': 'start',
      'msg': {
        'activeDataset': this._activeDataset,
        'initialSample': Object.keys(this._selectedSitesModel.getData()),
        'sampleSize': parseInt(sampleSizeStr),
        'numberGeneration': parseInt(numberGenerationStr),
        'populationSize': parseInt(populationStr),
        'nearestNeighbourSize': parseInt(nearestNeighborSizeStr),
        'algorithm': algorithm,
        'selectedVariables': selectedCriteria,
        'categoryFairnessVariables': categoryFairnessVariables,
        'historicWeightingCriteria': historicWeightingCriteria,
        'survivalCount': parseInt(survivalCountStr),
        'useMustHaveSites': useMustHaveSites,
        'noiseGenerationNumber': parseInt(noiseGenerationNumberStr)
      }
    });

    this._worker.onmessage = (event) => {
      this._updateCurrentProgress(event);
    };

    this._$modalElBody.html(TEMPLATE_BODY_PROCESSING);
    this._$modalElBody.find('.name span').html(nameStr);
    this._$modalElBody.find('.loader').css('background-image', 'url(' + loaderIcon + ')');

    this._$modalElFooter = this._$modalEl.find('.modal-footer');
    this._$modalElFooter.html(TEMPLATE_FOOTER_PROCESSING);
    this._$modalElFooter.find('.btn-minimise-maximise').click(OptimiseDialog._handleMinimiseMaximiseClick.bind(this));
    this._$modalElFooter.find('.btn-show-current-sample').click(this._handleShowCurrentSampleClick.bind(this));
    this._$modalElFooter.find('.btn-pause-resume').click(this._handlePauseResumeClick.bind(this));
    this._$modalElFooter.find('.btn-stop').click(this._handleStopClick.bind(this));
  }

  /**
   *
   * @param type
   * @return {Array}
   * @private
   */
  _buildCriteriaArray(type) {
    const criteriaArray = [];
    $(`table#calculations tbody tr[data-type="${type}"]`).get().forEach(row => {
      if ($(row).find('td.criteria-active input:checked').length === 1) {
        const weight = $(row).find('td.criteria-weight input').val();

        const criteria = this._variablesModel.getItems().find(item => item.id === $(row).data('aims-criteria-key'));
        if (criteria) {
          criteria.weight = parseFloat(weight) > 0 ? parseFloat(weight) : 0;
          criteriaArray.push(criteria)
        } else {
          criteriaArray.push({
            id:  $(row).data('aims-criteria-key'),
            weight: parseFloat(weight) > 0 ? parseFloat(weight) : 0
          });
        }
      }
    });
    return criteriaArray;
  }

  /**
   * Handle click on the start-optimising-button
   * @param event
   * @private
   */
  static _handleMinimiseMaximiseClick(event) {
    const $modal = $('#aims_msp_selected-sites-panel_optimise-dialog');
    $modal.toggleClass('minimised');
    if ($modal.hasClass('minimised')) {
      $modal.find('.btn-minimise-maximise').html('Maximise');
    } else {
      $modal.find('.btn-minimise-maximise').html('Minimise');
    }
    $('.modal-backdrop').toggle();
  }

  /**
   * Handle click on the start-optimising-button
   * @param event
   * @private
   */
  _handleShowCurrentSampleClick(event) {
    this._selectedSitesModel.setData(this._results[this._results.length - 1].sample);
  }

  /**
   * Handle click on the pause-resume button
   * @param event
   * @private
   */
  _handlePauseResumeClick(event) {
    if ($(event.target).html() === "Pause") {
      $(event.target).attr("disabled", "disabled");
      $(event.target).html("Resume");

      this._$modalElBody.find('.loader').find('.current-progress').html('Pausing optimisation');
      this._worker.postMessage({
        'cmd': 'pause',
        'msg': {}
      });
    } else {
      $(event.target).attr("disabled", "disabled");
      $(event.target).html("Pause");

      this._$modalElBody.find('.loader').find('.current-progress').html('Resuming optimisation');
      this._worker.postMessage({
        'cmd': 'resume',
        'msg': {}
      });
    }

  }

  /**
   * Handle click on the start-optimising-button
   * @param event
   * @private
   */
  _handleStopClick(event) {
    this._worker.postMessage({
      'cmd': 'stop',
      'msg': ''
    });
    this._$modalElBody.find('.loader').find('.current-progress').html('Stopped, updating display');
    this._finishOptimisation();
  }

  /**
   * Show new progress to user
   * @param event
   * @private
   */
  _updateCurrentProgress(event) {
    const message = event.data;

    if (message.hasOwnProperty('type')) {

      switch (message.type) {
        case 'app.utils.optimiser.initialisation-update':
        case 'app.utils.optimiser.generation-started':
          this._$modalElBody.find('.loader').find('.current-progress').html(message.data.status);
          break;
        case 'app.utils.optimiser.generation-finished':
          if (Array.isArray(message.data.sample)) {
            const resultSample = {};
            const _referenceSites = this._referenceSitesHashModel.getData();
            Object.keys(_referenceSites).forEach((_id) => {
              const index = message.data.sample.indexOf(_id);
              if (index >= 0) {
                // Reference site found in the list of uploaded ids.
                resultSample[_id] = {
                  id: _referenceSites[_id].id,
                  latitude: _referenceSites[_id].lat,
                  longitude: _referenceSites[_id].lon
                };
                message.data.sample.splice(index, 1);
              }
            });

            const result = {
              generation: message.data.generation,
              sample: resultSample,
              score: message.data.score,
              scoresMean: message.data.scoresMean,
              scoresVariance: message.data.scoresVariance,
              siteMoved: message.data.siteMoved,
              maxSiteMoved: message.data.maxSiteMoved,
            };

            const logDiv = this._$modalElBody.find('.log');
            logDiv.append(
              'Generation ' + message.data.generation + ' score: ' + message.data.score.toFixed(6) +
              ((this._results.length > 0 && this._results[this._results.length - 1].score !== message.data.score) ? ' <<< ' + (message.data.score - this._results[this._results.length - 1].score).toFixed(6) : '') +
              ' moved ' + message.data.siteMoved + '/' + message.data.maxSiteMoved + ' sites' +
              '<br>'
            );
            logDiv.animate({scrollTop: logDiv.prop('scrollHeight')});

            this._results.push(result);
          }
          break;
        case 'app.utils.optimiser.terminated':
          this._$modalElBody.find('.loader').find('.current-progress').html('Finished, updating display');
          this._finishOptimisation();
          break;
        case 'app.utils.optimiser.error':
          this._$modalElBody.html('<div class="alert alert-danger"><strong>Error:</strong> ' + message.data.message + '</div>');
          this._$modalElFooter.html(TEMPLATE_FOOTER_RESULTS);
          break;
        case 'app.utils.optimiser.paused':
          this._$modalElBody.find('.loader').find('.current-progress').html('Paused (generation ' + message.data.generation + ')');
          this._$modalElFooter.find('.btn-pause-resume').removeAttr("disabled");
          break;
        case 'app.utils.optimiser.resumed':
          this._$modalElBody.find('.loader').find('.current-progress').html('Resumed (generation ' + message.data.generation + ')');
          this._$modalElFooter.find('.btn-pause-resume').removeAttr("disabled");
          break;
      }
    }
  }

  /**
   * Update selected sites model and close modal
   * @private
   */
  _finishOptimisation() {
    if (this._results.length > 0) {
      this._selectedSitesModel.setData(this._results[this._results.length - 1].sample);
    }

    this._$modalElBody.html(TEMPLATE_BODY_RESULTS);

    const $downloadButton = $('<button type="button" class="btn btn-primary">Download results</button>');
    $downloadButton.click(this._downloadResults.bind(this));
    this._$modalElBody.find('.results').html($downloadButton);

    this._$modalElFooter = this._$modalEl.find('.modal-footer');
    this._$modalElFooter.html(TEMPLATE_FOOTER_RESULTS);
  }

  /**
   * Trigger the download of the result set
   * @private
   */
  _downloadResults() {
    // Add settings to result CSV
    let resultString =
      'Name,' +
      'Pre-selected sites,' +
      'Selected Criteria,' +
      'Category Fairness Variables,' +
      'Historic Weighting Criteria,' +
      'Algorithm,' +
      'Sample Size,' +
      'Number of Generations,' +
      'Population Size,' +
      'Survival Count,' +
      'Measurement Site Distance Jitter,' +
      'Use Must-Have-Sites,' +
      'Noise Generation Number,\n';

    resultString +=
      this._settings.name + ',' +
      this._settings.initialSample.reduce((samples, item) => samples += item + '; ', '') + ',' +
      this._settings.selectedVariables.reduce((variables, item) => variables += item.id + '; ', '')  + ',' +
      this._settings.categoryFairnessVariables.reduce((variables, item) => variables += item.id + '; ', '')  + ',' +
      this._settings.historicWeightingCriteria.reduce((variables, item) => variables += item.id + '; ', '')  + ',' +
      this._settings.algorithm  + ',' +
      this._settings.sampleSize + ',' +
      this._settings.numberGeneration + ',' +
      this._settings.populationSize + ',' +
      this._settings.survivalCount  + ',' +
      this._settings.nearestNeighbourSize  + ',' +
      this._settings.useMustHaveSites  + ',' +
      this._settings.noiseGenerationNumber  + ',\n';

    resultString += '\n\n';

    // Add results to result CSV
    resultString +=
      'Generation,' +
      'Score,' +
      'Scores Mean,' +
      'Scores Variance,' +
      'Site Moved,' +
      'Max Site Moved,\n';
    this._results.forEach(resultRow => {
      resultString +=
        resultRow.generation + ',' +
        resultRow.score + ',' +
        resultRow.scoresMean + ',' +
        resultRow.scoresVariance + ',' +
        resultRow.siteMoved + ',' +
        resultRow.maxSiteMoved + ',\n';
    });

    const filename = "results.csv";
    const file = new Blob([resultString], {type: "text/plain;charset=utf-8"});
    if (window.navigator.msSaveOrOpenBlob) // IE10+
      window.navigator.msSaveOrOpenBlob(file, filename);
    else { // Others
      const a = document.createElement("a"),
        url = URL.createObjectURL(file);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/dialogs/optimise-dialog.js